"use strict";

exports.__esModule = true;
exports.ReportEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactDebounceInput = require("react-debounce-input");
var _Undo = require("../../Core/Undo");
var _LayoutEditor = require("../../ConfigurableLayout/LayoutEditor");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _LayoutSettingsContext = require("../../ConfigurableLayout/LayoutSettingsContext");
var _ReportTagContext = require("../ReportTagContext");
var _DeviceTagSelector = require("../../Device/DeviceTagSelector");
var _WidgetsContext = require("../../Widgets/WidgetsContext");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _dec, _class, _ReportEditor;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ReportEditorContainer = _styledComponents["default"].div.withConfig({
  displayName: "ReportEditor__ReportEditorContainer",
  componentId: "sc-1jno529-0"
})(["& .", "{padding:0 1rem;height:40px;border-bottom:solid 1px rgba(0,0,0,0.2);color:", ";background:", ";.", "{background-color:", ";}.", "[aria-selected=\"true\"],.", ":not([aria-disabled=\"true\"]):hover{color:", ";}}"], _core.Classes.TAB_LIST, (0, _Theme.val)("ToolbarTextColor"), (0, _Theme.val)("ToolbarBackground"), _core.Classes.TAB_INDICATOR, (0, _Theme.val)("tabIndicatorColor"), _core.Classes.TAB, _core.Classes.TAB, (0, _Theme.val)("tabIndicatorColor"));
var GlobalStyles = (0, _styledComponents.createGlobalStyle)(["body{.", "{z-index:100;}}"], _core.Classes.TRANSITION_CONTAINER);

/**
 * An interface for editing reports
 */
var ReportEditor = exports.ReportEditor = (_dec = _LayoutSettingsContext.LayoutSettingsContext.withContext, (0, _Core.withTranslator)(_class = (0, _WidgetsContext.withWidgetsContext)(_class = (0, _userActionsContext.withUserActionsContext)(_class = _dec(_class = (_ReportEditor = /*#__PURE__*/function (_Component) {
  function ReportEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value,
      selectedTabId: "editor",
      isReportNameAlreadyExist: false
    };
    _this.handleTabChange = function (selectedTabId) {
      return _this.setState({
        selectedTabId: selectedTabId
      });
    };
    _this.handleLayoutChange = function (value) {
      _this.setState({
        value: value
      });
    };
    return _this;
  }
  _inheritsLoose(ReportEditor, _Component);
  ReportEditor.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var value = _ref.value;
    if (value === prevState.value) {
      return null;
    }
    return {
      value: value
    };
  };
  var _proto = ReportEditor.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      widgets = _this$props.widgets,
      onSubmit = _this$props.onSubmit,
      onDelete = _this$props.onDelete,
      onDuplicate = _this$props.onDuplicate,
      translator = _this$props.translator,
      layoutSettings = _this$props.layoutSettings,
      userActions = _this$props.userActions,
      checkIfReportWithProvidedNameExist = _this$props.checkIfReportWithProvidedNameExist;
    var translate = translator.translate;
    var _this$state = this.state,
      value = _this$state.value,
      selectedTabId = _this$state.selectedTabId,
      isReportNameAlreadyExist = _this$state.isReportNameAlreadyExist;
    var settings = layoutSettings && Object.assign({}, layoutSettings, {
      editorSettings: Object.assign({}, layoutSettings.editorSettings, {
        editMode: true
      })
    });
    return /*#__PURE__*/_react["default"].createElement(_LayoutSettingsContext.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_Undo.UndoController, {
      value: value,
      onChange: this.handleLayoutChange
    }, function (undoController) {
      return /*#__PURE__*/_react["default"].createElement(_Undo.UndoContext.Provider, {
        value: undoController
      }, /*#__PURE__*/_react["default"].createElement(GlobalStyles, null), /*#__PURE__*/_react["default"].createElement(ReportEditorContainer, {
        "data-testid": "ReportEditor.Container"
      }, /*#__PURE__*/_react["default"].createElement(_ReportTagContext.ReportTagContext.Consumer, null, function (_ref2) {
        var _undoController$state, _undoController$state2;
        var loading = _ref2.loading,
          reportTags = _ref2.data;
        if (loading) {
          return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
        }
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
          id: "ReportEditorTabs",
          selectedTabId: selectedTabId,
          onChange: _this2.handleTabChange
        }, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
          id: "editor",
          title: "Editor"
        }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
          id: "details",
          title: "Details"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _core.Classes.FLEX_EXPANDER
        }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
          style: {
            marginLeft: "1rem"
          }
        }, /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "ReportEditor.saveButton",
          icon: _icons.IconNames.FLOPPY_DISK,
          intent: _core.Intent.PRIMARY,
          text: translate("ReportEditor.saveButton.text", "Save"),
          successText: translate("ReportEditor.saveButton.successText", "Saved"),
          onClick: function onClick() {
            onSubmit(undoController.state);
          },
          disabled: !undoController.state.name || isReportNameAlreadyExist || ((_undoController$state = undoController.state.element.props) == null || (_undoController$state = _undoController$state.rolesVisibility) == null ? void 0 : _undoController$state.length) === 0 || ((_undoController$state2 = undoController.state.element.props) == null || (_undoController$state2 = _undoController$state2.usersVisibility) == null ? void 0 : _undoController$state2.length) === 0
        }), onDuplicate && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "ReportEditor.duplicateButton",
          icon: _icons.IconNames.DUPLICATE,
          text: translate("ReportEditor.duplicateButton.text", "Duplicate"),
          onClick: function onClick() {
            return onDuplicate(undoController.state);
          },
          minimal: true
        }), onDelete && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "ReportEditor.deleteButton",
          icon: _icons.IconNames.TRASH,
          intent: _core.Intent.DANGER,
          text: translate("ReportEditor.deleteButton.text", "Delete"),
          confirm: /*#__PURE__*/_react["default"].createElement(_Core.Text, null, translate("ReportEditor.deleteButton.confirmText", "Are you sure you want to delete this report? This action cannot be undone.")),
          onClick: function onClick() {
            return onDelete(undoController.state);
          },
          minimal: true
        }))))), selectedTabId === "details" && /*#__PURE__*/_react["default"].createElement(_Core.Content, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: translate("ReportEditor.nameInput.label", "Report Name"),
          helperText: isReportNameAlreadyExist ? translate("ReportEditor.nameInput.validation.nameAlreadyExist", "Name for the report is already taken.") : translate("ReportEditor.nameInput.helperText", "A descriptive name for the report."),
          intent: isReportNameAlreadyExist ? _core.Intent.DANGER : _core.Intent.NONE
        }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
          element: _core.InputGroup,
          debounceTimeout: 300,
          style: {
            width: 300,
            border: isReportNameAlreadyExist ? "solid red 2px" : undefined
          },
          "data-testid": "ReportEditor.nameInput",
          placeholder: translate("ReportEditor.nameInput.placeholder", "Untitled Report"),
          maxLength: 35,
          onChange: (/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
              var isReportExist;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return checkIfReportWithProvidedNameExist(e.target.value);
                  case 1:
                    isReportExist = _context.v;
                    if (isReportExist) {
                      _this2.setState({
                        isReportNameAlreadyExist: true
                      });
                    } else {
                      undoController.setState({
                        name: e.target.value
                      });
                      _this2.setState({
                        isReportNameAlreadyExist: false
                      });
                    }
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }()),
          value: undoController.state.name
        })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: translate("ReportEditor.descriptionInput.label", "Description"),
          helperText: translate("ReportEditor.descriptionInput.helperText", "A short description of the report.")
        }, /*#__PURE__*/_react["default"].createElement(_core.TextArea, {
          className: _core.Classes.FILL,
          "data-testid": "ReportEditor.descriptionInput",
          style: {
            width: 500
          },
          maxLength: 140,
          rows: 4,
          onChange: function onChange(e) {
            var value = e.target.value;
            undoController.setState(function (state) {
              return {
                element: Object.assign({}, state.element, {
                  props: Object.assign({}, state.element.props, {
                    description: value
                  })
                })
              };
            });
          },
          value: undoController.state.element.props.description || ""
        })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          name: "tags",
          label: translate("Report Editor.tagInput.tags", "Report Tags"),
          helperText: translate("reportEditor.tagInput.helperText", "Separate multiple tags with comma")
        }, /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
          shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
            return !reportTags.find(function (tag) {
              return tag === value;
            });
          },
          multiple: true,
          items: reportTags,
          onSelect: function onSelect(selectedTags) {
            undoController.setState({
              tags: selectedTags
            });
          },
          selected: undoController.state.tags || [],
          rightIcon: _icons.IconNames.CARET_DOWN,
          minimal: true
        }))), selectedTabId === "editor" && /*#__PURE__*/_react["default"].createElement(_LayoutEditor.LayoutEditor, {
          widgets: value.element.type === "DeviceDetails" ? widgets.deviceDetailsWidgets : widgets.reportWidgets,
          value: undoController.state,
          onChange: undoController.setState,
          userActions: userActions
        }));
      })));
    }));
  };
  return ReportEditor;
}(_react.Component), _ReportEditor.defaultProps = {
  translator: undefined,
  layoutSettings: undefined,
  widgets: undefined,
  userActions: undefined
}, _ReportEditor)) || _class) || _class) || _class) || _class);